import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon fill="none" viewBox="0 0 16 16" {...props}>
    <path d="M11 2L5 8L11 14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
